export const SET_REGISTER_LIST_COURSES = "SET_REGISTER_LIST_COURSES";
export const SET_DELETE_ITEM_COURSES = "SET_DELETE_ITEM_COURSES";
